import Alert from "./alert";
import Footer from "./footer";
import Header from "./header";
import Meta from "./meta";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";

export default function Layout({ preview, children }) {
  return (
    <>
      <Meta />
      <div className="min-h-full">
        <Alert preview={preview} />
        <main className="flex justify-center">{children}</main>
      </div>
      
    </>
  );
}
